import styled from "styled-components";

export const StyledFooter = styled.footer`
background-color: var(--primary-color);
color:white;
padding: 25px;
text-align: center;
position: fixed;
bottom: 0;
width:100%;

p{
    font-weight: var(--font-weight-5);
}

`